// removed by extract-text-webpack-plugin
module.exports = {"t-scroll":"EKCrRupn7_IoIptYo7RVl","full-width":"_3XoQrmj66Qh0aDZLSHec2u","inlineBlock":"_1TjEWRjhcBPJa3W8TABQ0j","bold":"_2Xy829K1R5Swq3skSPvzjB","no-padding":"_2CpkIIhXEH1OBBdkOBlaHN"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/style.scss
// module id = 538
// module chunks = 0